/* Florema · selector de aroma de los PACKS, celular y escritorio (oct 2026)
   Opción 1 "Un aroma + interruptor" (aprobada por Luis): una fila deslizable de mini-frascos con la foto de los dos
   productos del pack juntos, las notas del aroma y el interruptor "Mismo aroma para los dos". Al apagarlo aparece una
   fila por producto.

   Cómo se integra (no cambia ni el Liquid ni la lógica de variantes):
   - Las listas de aroma originales y el interruptor [data-same-aroma-toggle] siguen en el formulario, ocultos con CSS
     en celular. Siguen siendo los que mandan la variante.
   - Este bloque solo LEE y marca esos radios (y dispara el mismo evento "change"), y aprieta el mismo interruptor, para que
     florema-pdp.js siga sincronizando: lámina pack2-<aroma>, <select name="id">, barra "Tu pack", etc.
   - Solo corre en /products/pack-* que tengan dos listas de aroma. Pack Descubrimiento y demás: no hace nada.
   - Se ve en todos los anchos (en escritorio con frascos de 64 px); el selector del tema queda oculto en ambos.
   - Fotos y notas: se leen de /products/<handle>.js de los productos individuales (mismo método que el selector de las
     fichas individuales). Si algo falla, usa el texto del propio pack y la fila queda sin foto, sin romper nada. */
(function () {
  'use strict';
  if (window.__flPacks) return;
  var doc = document, root = doc.documentElement;
  var m = location.pathname.match(/^\/products\/([^\/?#]+)/);
  var PACK = m ? m[1] : '';
  if (!/^pack-/.test(PACK)) return;

  /* ---- Handles de cada producto individual, por aroma (claves sin tildes ni mayúsculas) ----
     Ojo: Tropical vive en productos con handle "…uvana…copia" / "…mangolu…copia"; el título es el que manda. */
  var H = {
    dif150: { vitali: 'difusor-aromatico-vitali-150ml', tropical: 'difusor-aromatico-uvana-150ml-copia', uvana: 'difusor-aromatico-uvana-150ml', roma: 'difusor-aromatico-roma-150ml', sugar: 'sugar-difusor-aromatico-150ml', mangolu: 'difusor-aromatico-mangolu-150ml', bloom: 'bloom-difusor-aromatico-150ml', fresh: 'fresh-difusor-aromatico-150ml' },
    hs250: { vitali: 'home-spray-vitali-250ml', tropical: 'home-spray-uvana-250ml-copia', uvana: 'home-spray-uvana-250ml', roma: 'home-spray-roma-250ml', sugar: 'home-spray-sugar-250ml', mangolu: 'home-spray-mangolu-250ml', bloom: 'bloom-home-spray-250ml', fresh: 'home-spray-fresh-250ml' },
    dif100: { vitali: 'difusor-aromatico-110ml-vitali', tropical: 'difusor-aromatico-100ml-uvana-copia', uvana: 'difusor-aromatico-110ml-uvana', roma: 'difusor-aromatico-110ml-roma', sugar: 'difusor-aromatico-110ml-sugar', mangolu: 'difusor-aromatico-110ml-mangolu', bloom: 'difusor-aromatico-110ml-bloom', fresh: 'difusor-aromatico-110ml-fresh' },
    hs130: { vitali: 'home-spray-vitali-130ml', tropical: 'home-spray-mangolu-130ml-copia', uvana: 'uvana-home-spray-130ml', roma: 'home-spray-roma-130ml', sugar: 'sugar-home-spray-130ml', mangolu: 'home-spray-mangolu-130ml', bloom: 'home-spray-bloom-130ml', fresh: 'fresh-home-spray-130ml' },
    refil500: { vitali: 'home-spray-vitali-500ml', tropical: 'refil-home-spray-uvana-500ml-copia', uvana: 'refil-home-uvana-500ml', roma: 'refil-home-roma-500ml', sugar: 'refil-home-sugar-500ml', mangolu: 'refil-home-mangolu-500ml', bloom: 'refil-home-bloom-500ml', fresh: 'refil-home-fresh-500ml' }
  };
  var PACKS = {
    'pack-difusor-150ml-home-spray-250ml': [H.dif150, H.hs250],
    'pack-difusor-100ml-home-130ml': [H.dif100, H.hs130],
    'pack-home-spray-130ml-refil-home-spray-500ml': [H.hs130, H.refil500]
  };
  var MAPA = PACKS[PACK];
  if (!MAPA) return;

  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function norm(s) { return String(s || '').replace(/ /g, ' ').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  var form, wraps, groups, toggle, host, NOMBRES = [], FALLBACK = [{}, {}], INFO = {}, PIDE = {}, VENCIO = false;

  /* ---------- datos de los productos individuales (foto + notas), con caché de sesión ---------- */
  function notasDeDescripcion(html) {
    var p = String(html || '').split('Notas principales de la fragancia');
    if (p.length < 2) return '';
    var t = p[p.length - 1].split('</p>')[0].split(':').pop();
    try { t = new DOMParser().parseFromString(t.replace(/<[^>]+>/g, ' '), 'text/html').body.textContent || ''; } catch (e) { t = t.replace(/<[^>]+>/g, ' '); }
    return formatoNotas(t.replace(/\./g, ''));
  }
  function formatoNotas(t) { /* "Rosas, frambuesa, dulce vainilla, ámbar" -> "Rosas · Frambuesa · Vainilla" (3 notas como máximo) */
    var vistos = {}, l = String(t || '').replace(/ /g, ' ').split(/\s*[·,]\s*|\s+y\s+/).map(function (x) { return x.trim().replace(/^dulce\s+/i, ''); })
      .filter(function (x) { var k = norm(x); if (!k || vistos[k]) return false; vistos[k] = 1; return true; })
      .map(cap);
    return l.slice(0, 3).join(' · ');
  }
  function pedir(handle) {
    if (!handle) return Promise.resolve(null);
    if (PIDE[handle]) return PIDE[handle];
    var k = 'flPk2:' + handle, c = null;
    try { c = JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) {}
    if (c) { INFO[handle] = c; return (PIDE[handle] = Promise.resolve(c)); }
    return (PIDE[handle] = fetch('/products/' + handle + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
      var img = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') : '';
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      var o = { img: img, notes: notasDeDescripcion(p.description) };
      INFO[handle] = o;
      try { sessionStorage.setItem(k, JSON.stringify(o)); } catch (e) {}
      return o;
    }).catch(function () { INFO[handle] = { img: '', notes: '', fail: true }; return null; }));
  }
  function hnd(g, key) { return MAPA[g][key] || ''; }

  /* ---------- estado leído de los radios originales ---------- */
  function radios(g) { return $$('input[type="radio"]', groups[g]); }
  function val(g) { var c = $('input:checked', groups[g]); return c ? c.value : ''; }
  function mismo() { return toggle.getAttribute('aria-pressed') === 'true'; }
  function poner(g, v) {
    var i = radios(g).filter(function (x) { return x.value === v; })[0];
    if (i && !i.checked) { i.checked = true; i.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  function ligar(on) { if (mismo() !== on) toggle.click(); }

  function notasDe(key) {
    var o = INFO[hnd(0, key)];
    if (o && o.notes) return o.notes;
    if (o && !o.fail && !VENCIO) return '';            /* todavía cargando: espera un momento para no parpadear */
    return FALLBACK[0][key] || '';
  }

  /* ---------- piezas ---------- */
  function chips(g) {
    return radios(g).map(function (r) {
      var key = norm(r.value), a = hnd(0, key), b = hnd(1, key);
      var ph = g === 0
        ? '<img data-h="' + esc(a) + '" alt="" loading="eager" draggable="false"><img data-h="' + esc(b) + '" alt="" loading="eager" draggable="false">'
        : '<img data-h="' + esc(b) + '" alt="" loading="eager" draggable="false">';
      return '<button type="button" class="flpk__chip" data-g="' + g + '" data-v="' + esc(r.value) + '" aria-pressed="false" aria-label="' + esc(r.value) + '"><span class="flpk__ph">' + ph + '</span><span class="flpk__lb">' + esc(r.value) + '</span></button>';
    }).join('');
  }
  function rail(g) { return '<div class="flpk__railwrap"><div class="flpk__rail" role="group" aria-label="Aroma · ' + esc(NOMBRES[g]) + '" data-rail="' + g + '">' + chips(g) + '</div></div>'; }
  function notas(g) { return '<div class="flpk__n" data-nrow="' + g + '"><span class="flpk__k">Notas</span><b class="flpk-sw" data-n="' + g + '"></b></div>'; }

  function re(el) { if (!el) return; el.classList.remove('flpk-sw'); void el.offsetWidth; el.classList.add('flpk-sw'); }
  function setN(g, texto) {
    var el = $('[data-n="' + g + '"]', host); if (!el) return;
    if (el.textContent !== texto) { el.textContent = texto; if (texto) re(el); }
  }
  function centra(rl, n) {
    var c = $$('.flpk__chip', rl).filter(function (x) { return x.getAttribute('data-v') === n; })[0];
    if (!c || !rl.clientWidth) return;
    if (c.offsetLeft - rl.scrollLeft + c.offsetWidth > rl.clientWidth - 40 || c.offsetLeft < rl.scrollLeft)
      rl.scrollTo({ left: Math.max(0, c.offsetLeft - (rl.clientWidth - c.offsetWidth) / 2), behavior: 'smooth' });
  }
  function marca(rl, n) { $$('.flpk__chip', rl).forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-v') === n ? 'true' : 'false'); }); centra(rl, n); }

  function fotos() { /* pone el src de cada foto cuando su producto ya cargó */
    $$('img[data-h]', host).forEach(function (im) {
      if (im.getAttribute('src')) return;
      var o = INFO[im.getAttribute('data-h')];
      if (o && o.img) { im.src = o.img; }
    });
  }

  function pinta() {
    if (!host) return;
    var d = val(0), h = val(1), m = mismo();
    host.classList.toggle('flpk--split', m);
    $('[data-grp="1"]', host).hidden = m; $('[data-lab="0"]', host).hidden = m;
    $('[data-sw]', host).setAttribute('aria-pressed', m ? 'true' : 'false');
    /* con aromas distintos la fila del primer producto muestra solo su foto */
    $$('[data-rail="0"] .flpk__ph', host).forEach(function (ph) { var im = $$('img', ph); if (im[1]) im[1].hidden = !m; });
    marca($('[data-rail="0"]', host), d); marca($('[data-rail="1"]', host), h);
    setN(0, notasDe(norm(d))); setN(1, notasDe(norm(h)));
    fotos();
  }

  function elegir(g, n) { poner(g, n); pinta(); }

  /* ---------- construcción ---------- */
  function construir() {
    var cs = getComputedStyle(wraps[0]);
    host = doc.createElement('section');
    host.className = 'flpk flpk--split';
    host.setAttribute('aria-label', 'Aroma del pack');
    host.style.marginTop = cs.marginTop; host.style.marginBottom = cs.marginBottom; host.style.order = cs.order;
    host.innerHTML =
      '<div class="flpk__g" data-grp="0"><div class="flpk__lab" data-lab="0" hidden><span class="flpk__k">' + esc(NOMBRES[0]) + '</span></div>' + rail(0) + notas(0) + '</div>' +
      '<div class="flpk__g" data-grp="1" hidden><div class="flpk__lab"><span class="flpk__k">' + esc(NOMBRES[1]) + '</span></div>' + rail(1) + notas(1) + '</div>' +
      '<button type="button" class="flpk__swrow" data-sw aria-pressed="true"><span class="t">Mismo aroma para los dos<i>Recomendado</i></span><span class="flpk__trk" aria-hidden="true"></span></button>';
    wraps[0].parentNode.insertBefore(host, wraps[0]);
    root.classList.add('fl-pk-on');

    host.addEventListener('click', function (e) {
      var c = e.target.closest('.flpk__chip');
      if (c) { elegir(parseInt(c.getAttribute('data-g'), 10), c.getAttribute('data-v')); return; }
      if (e.target.closest('[data-sw]')) { ligar(!mismo()); return; }
    });
    var tmr, rp = function () { cancelAnimationFrame(tmr); tmr = requestAnimationFrame(pinta); };
    form.addEventListener('change', rp, true);
    new MutationObserver(rp).observe(toggle, { attributes: true, attributeFilter: ['aria-pressed'] });
    pinta();
    $$('.flpk__rail', host).forEach(function (rl) { var c = $('[aria-pressed="true"]', rl); if (c) rl.scrollLeft = Math.max(0, c.offsetLeft - (rl.clientWidth - c.offsetWidth) / 2); });

    /* "Cambiar" de la barra fija: el selector del tema queda oculto en celular, así que lleva a este bloque */
    doc.addEventListener('click', function (e) {
      if (!(e.target.closest && e.target.closest('[data-pdp-sticky-change]')) || !host) return;
      /* en escritorio la columna de compra es "sticky" y queda desplazada hacia arriba: scrollIntoView apunta a una
         posición que se mueve; se calcula el lugar natural del bloque (sin el desplazamiento del sticky) */
      var info = host.closest('.florema-pdp__info');
      if (info && getComputedStyle(info).position === 'sticky' && info.parentElement) {
        var nat = info.parentElement.getBoundingClientRect().top + window.pageYOffset + (host.getBoundingClientRect().top - info.getBoundingClientRect().top);
        window.scrollTo({ top: Math.max(0, nat - innerHeight * 0.3), behavior: 'smooth' });
      } else host.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { host.classList.remove('fl-aqui'); void host.offsetWidth; host.classList.add('fl-aqui'); setTimeout(function () { host.classList.remove('fl-aqui'); }, 1600); }, 500);
    });
    window.__flPacks = { elegir: elegir, ligar: ligar, estado: function () { return { a: val(0), b: val(1), mismo: mismo() }; } };
  }

  function cargarDatos() {
    var ps = [];
    radios(0).forEach(function (r) {
      var k = norm(r.value);
      ps.push(pedir(hnd(0, k)).then(function () { pinta(); }));
      ps.push(pedir(hnd(1, k)).then(function () { fotos(); }));
    });
    setTimeout(function () { VENCIO = true; pinta(); }, 1200);
    return ps;
  }

  /* ---------- arranque: espera a que el tema arme el interruptor y las listas ---------- */
  var intentos = 0;
  function arrancar() {
    form = $('[data-pdp-form]');
    if (!form) return reintenta();
    wraps = $$('.florema-pdp__option', form);
    groups = $$('[data-pdp-variants]', form);
    toggle = $('[data-same-aroma-toggle]', form);
    if (groups.length < 2 || !toggle || !radios(0).length) return reintenta();
    if (host) return;
    NOMBRES = groups.map(function (g) { var i = $('input', g); return ((i && i.name.match(/\[(.*)\]/)) || [0, ''])[1].replace(/(\d)\s*ml/i, '$1 ml').replace(/^Home(?= \d)/i, 'Home Spray'); });
    /* respaldo si falla la descarga: texto de notas de las tarjetas del propio pack (recortado a 2 por el Liquid) */
    radios(0).forEach(function (r) {
      var lb = r.id && $('label[for="' + r.id + '"] .florema-pdp__variant-notes', form);
      FALLBACK[0][norm(r.value)] = lb ? formatoNotas(lb.textContent) : '';
    });
    /* el aroma de cada lista debe tener su producto individual; si falta alguno, no se toca el selector del tema */
    var todos = radios(0).concat(radios(1)).every(function (r) { return MAPA[0][norm(r.value)] && MAPA[1][norm(r.value)]; });
    if (!todos) return;
    construir();
    /* las fotos y notas se piden solo en celular (en escritorio el bloque está oculto) */
    cargarDatos();
    /* en escritorio, si los 8 frascos no caben, se muestra el degradado y se puede deslizar */
    var ovf = function () { var rl = $('[data-rail="0"]', host); if (!rl) return; host.classList.remove('flpk--ovf'); var o = rl.scrollWidth > rl.clientWidth + 1; host.classList.toggle('flpk--ovf', o); };
    ovf(); setTimeout(ovf, 600); window.addEventListener('resize', ovf); window.addEventListener('load', ovf);
  }
  function reintenta() { if (++intentos < 80) setTimeout(arrancar, 150); }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', arrancar); else arrancar();
})();
